import { Filter } from './filter';
import { Order } from './order';

export const DEFAULT_OFFSET = 0;
export const DEFAULT_LIMIT = 25;
export const DEFAULT_PAGE_INDEX = 0;
export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 50;

export interface Count {
  /**
   * Total general de items.
   */
  totalItemCount: number;

  /**
   * Filtros aplicados.
   */
  filters?: Array<Filter>;
}

export interface Pagination {
  /**
   * Índice de la página que se está devolviendo.
   */
  pageIndex: number;

  /**
   * Cantidad de items por página.
   */
  pageSize: number;
}

export interface PagedList<TItem> extends Count, Pagination {
  /**
   * Lista de items a devolver (en una página).
   */
  items: Array<TItem>;

  /**
   * Conjunto ordenado por.
   */
  orderBy: Array<Order>;
}
